import {getMethod,download} from './data'
import request from '@/utils/request'
// 新增告知书
export  function addnotice(data) {
    return request({
        url: '/api/notice' ,
        method: 'post',
        data
    })
}
// 查询告知书 /api/notice
export function getnotice(data) {
    return getMethod('/api/notice',data)
}
// 查询产品 product/queryByName
export function getqueryByName(data) {
    return getMethod('/api/product/queryByName',data)
}
// 告知书预览 
export  function noticepreview(data) {
    return request({
        url: '/api/notice/preview' ,
        method: 'post',
        data
    })
}
// /api/notice/{id} 告知书详情
export  function noticedetail(data) {
    return request({
        url: '/api/notice/'+data ,
        method: 'get',
    })
}
// /api/notice/sign
export  function noticesign(data) {
    return request({
        url: '/api/notice/sign' ,
        method: 'post',
        data
    })
}